import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=edd14a12&scoped=true"
import script from "./Branding.vue?vue&type=script&lang=js"
export * from "./Branding.vue?vue&type=script&lang=js"
import style0 from "./Branding.vue?vue&type=style&index=0&id=edd14a12&prod&lang=scss&scoped=true"
import style1 from "./Branding.vue?vue&type=style&index=1&id=edd14a12&prod&scoped=true&lang=css"
import style2 from "./Branding.vue?vue&type=style&index=2&id=edd14a12&prod&lang=css"
import style3 from "./Branding.vue?vue&type=style&index=3&id=edd14a12&prod&scoped=true&lang=css"
import style4 from "./Branding.vue?vue&type=style&index=4&id=edd14a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd14a12",
  null
  
)

export default component.exports